<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
    </div>

    <v-flex xs12>
      <!-- <social-score></social-score> -->

      <v-card class="mx-auto" tile>
        <template>
          <v-container class="mb-0 pb-0">
            <v-row>

              <v-col cols="12" md="12" class="text-right pb-0 pt-5">
                <div class="d-flex align-center justify-end">
                  <div>
                    <date-tab-filter :dates="dates" :period="period" v-on:update:filter="filter = $event" v-on:update:period="period = $event" v-on:update:dates="dates = $event"></date-tab-filter>
                  </div>

                  <!-- Filtro por rango de fecha -->
                  <div class="ml-3">
                    <date-filter :dates="dates" :filter="filter" v-on:update:change="dates = $event"></date-filter>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <finance-reports :dates="dates" :period="period"></finance-reports>
        <statistics-reports :dates="dates" :period="period"></statistics-reports>
      </v-card>

    </v-flex>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
// import SocialScore from './components/SocialScore'
import FinanceReports from './components/FinanceReports'
import StatisticsReports from './components/StatisticsReports'
import DateTabFilter from './components/DateTabFilter.vue'
import DateFilter from './components/DateFilter.vue'

export default {
  name: 'Default',
  components: {
    // SocialScore,
    FinanceReports,
    StatisticsReports,
    DateTabFilter,
    DateFilter
  },
  data () {
    return {
      section: this.$i18n.t('reports.section'),
      overlay: false,
      filter: 0,
      period: 'week',
      areas: [],
      dates: []
    }
  }
}
</script>

<style lang="scss">
  .color-black {
    color: #000 !important;
  }

  .group-results {
    th {
      font-size: 14px !important;
    }

    .v-row-group__header {
      background: none !important;
    }
  }

  .report-big-half-container-1 {
    border-left: 1px solid #D7D7D7;
  }

  .report-half-container-1 {
    border-left: 1px solid #D7D7D7;
    min-height: 150px;
  }
</style>
